import axios from "axios";

export const getTip = (tip_id: string, isPublic = true) => {
  return axios.get(`/v1/tips/${[tip_id]}/public`);
};

export const getPricingTiers = () => {
  return axios.get("v1/pricing/tips/tiers");
};

export const getUserCoupon = () => axios.get("/v1/me/coupons/available");

export interface GetUserTicketsResponse {
  coupons: TipTicket[];
}

export interface TipTicket {
  id: string;
  type?: TicketType;
  tipster_id?: string;
  user_id: string;
  // deprecated
  pricing_tier_code?: string;
  is_given: boolean;
  state: TicketState;
  current_unlocked_tip_id: string | null;
  created_at: string;
  updated_at: string;
}

export type TicketType = "TIPSTER" | "UNIVERSAL" | "";
export type TicketTypeKey = "Tipster" | "Universal" | "OldType";
export const TICKET_TYPES: Record<TicketTypeKey, TicketType> = {
  Tipster: "TIPSTER",
  Universal: "UNIVERSAL",
  OldType: "",
};
export const TICKET_TYPES_REVERSED: Record<TicketType, TicketTypeKey> = {
  TIPSTER: "Tipster",
  UNIVERSAL: "Universal",
  "": "OldType",
};

export type TicketState = "AVAILABLE" | "CONSUMED" | "IN_USE";
export type TicketStateKey = "Available" | "Consumed" | "In Use";
export const TICKET_STATES: Record<TicketStateKey, TicketState> = {
  Available: "AVAILABLE",
  Consumed: "CONSUMED",
  "In Use": "IN_USE",
};
export const TICKET_STATES_REVERSED: Record<TicketState, TicketStateKey> = {
  AVAILABLE: "Available",
  CONSUMED: "Consumed",
  IN_USE: "In Use",
};
